import { CSSProperties, FC, ReactNode } from 'react';

interface AnimatedStepProps {
  isVisible?: boolean;
  children: ReactNode;
  duration?: number;
  offset?: number;
  center?: boolean;
  className?: string;
}

export const AnimatedStep: FC<AnimatedStepProps> = ({
  isVisible = false,
  children,
  duration = 0.6,
  offset = 40,
  center = false,
  className = '',
}) => {
  const style: CSSProperties = {
    visibility: isVisible ? 'visible' : 'hidden',
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0px)' : `translateY(${offset}px)`,
    transition: `opacity ${duration}s ease, transform ${duration}s ease`,
    margin: center ? `0 auto` : undefined,
  };

  return (
    <div style={style} className={`${className} animated-step`}>
      {children}
    </div>
  );
};
